import { groupBy, map, minBy, omit, sortBy } from 'lodash';
import uuid from 'uuid';

import generatePostLogicItemPlaceholder from 'utils/generatePostLogicItemPlaceholder';
import postLogicRuleActions from 'config/postLogicRuleActions';

export const mapPostLogicRuleFromApiModel = ({
  id,
  attributes: {
    comparator,
    points,
    data: { value },
  },
  relationships: {
    item: {
      data: { id: questionId },
    },
  },
}) => ({
  questionId,
  id,
  trigger: comparator,
  answer: value,
  points: Math.abs(points),
  action: points > 0 ? postLogicRuleActions.add : postLogicRuleActions.deduct,
});

const sortPostLogicItemsByFirstAddedRule = items =>
  sortBy(items, item => minBy(item.rules, 'id').id);

export const mapPostLogicFromApiModel = response => {
  const rules = response.data.map(mapPostLogicRuleFromApiModel);
  const groupedRulesByQuestions = groupBy(rules, 'questionId');
  const items = map(groupedRulesByQuestions, (rules, questionId) => ({
    id: uuid(),
    questionId,
    rules: rules.map(rule => ({
      clientId: uuid(),
      ...omit(rule, 'questionId'),
    })),
  }));

  const sortedItems = sortPostLogicItemsByFirstAddedRule(items);
  return sortedItems.length
    ? sortedItems
    : [generatePostLogicItemPlaceholder()];
};

export const mapPostSurveyRuleToApiModel = (
  questionId,
  { trigger, answer, action, points },
) => ({
  item_id: questionId,
  comparator: trigger,
  data: {
    value: answer,
  },
  points: action === postLogicRuleActions.add ? points : -points,
});
